module.exports = __webpack_public_path__ + "static/highlightnodes-03f99006af607782c62ce095ae4edae4.mp4";